import React from 'react';

import { Input, Table, Tag } from 'antd';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';

import { TableSearchPanel } from 'ui/TableSearchPanel';
import { checkValue, debounce, formatDate } from 'utils';
import { PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { renderWithTooltip } from 'utils/table';

function PromocodesTable({
  items,
  current,
  pageSize,
  loading,
  totalRows,
  onChange,
  onSearch,
}) {
  const columns = [
    {
      width: 150,
      title: 'Промокод',
      dataIndex: 'promocode',
      key: 'promocode',
    },
    {
      title: 'Клиент',
      dataIndex: 'client_name',
      key: 'client_name',
      render: (value) => renderWithTooltip(value),
      filterDropdown: ({ selectedKeys, confirm }) => {
        return (
          <TableSearchPanel>
            <Input
              autoFocus
              placeholder="Поиск по клиенту"
              value={selectedKeys[0]}
              onChange={debounce(onSearch, 800)}
              onMouseLeave={() => confirm()}
            />
          </TableSearchPanel>
        );
      },
      filterIcon: () => <SearchOutlined />,
      onFilter: (value, record) => {
        return record?.client_name?.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: 'Услуга',
      dataIndex: 'service',
      key: 'service',
      render: checkValue,
    },
    {
      title: 'Статус',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive) => (
        <Tag color={isActive ? 'green' : 'red'}>
          {isActive ? 'Активный' : 'Не активный'}
        </Tag>
      ),
      filters: [
        {
          text: 'Активные',
          value: true,
        },
        {
          text: 'Не активные',
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      filterIcon: () => <FilterOutlined />,
    },
    {
      title: 'Дата активации',
      dataIndex: 'activation_date',
      key: 'activation_date',
      render: (value) => formatDate(value),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      loading={loading}
      tableLayou="fixed"
      scroll={{ y: SCROLL_Y }}
      pagination={{
        current,
        pageSize,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      rowKey="id"
      onChange={onChange}
    />
  );
}

export { PromocodesTable };
